import { render, staticRenderFns } from "./MessagePayment.vue?vue&type=template&id=3d8c9d2e"
import script from "./MessagePayment.vue?vue&type=script&lang=js"
export * from "./MessagePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports